import CryptoJS from "crypto-js";

const SECRET_KEY = "AxoneInfotechIndia21112007_MeeraJewelleryHouse_2025_RememberMePassword";

export const encrypt = (text) => {
    return CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
};

export const decrypt = (cipher) => {
    try {
        const bytes = CryptoJS.AES.decrypt(cipher, SECRET_KEY);
        return bytes.toString(CryptoJS.enc.Utf8);
    } catch {
        return "";
    }
};
